<script lang="ts" setup>
import { ref } from 'vue'

import { useTracksLiveKit } from '../../model/tracks-live-kit.hook'
import { useMediaBindingLiveKit } from '../../model/media-binding-live-kit.hook'

defineOptions({
  name: 'AudioRenderer',
})

const { remoteAudioTrack, remoteScreenAudioTrack } = useTracksLiveKit()

const audioEl = ref<HTMLAudioElement | null>(null)
const screenAudioEl = ref<HTMLAudioElement | null>(null)

useMediaBindingLiveKit(audioEl, remoteAudioTrack)
useMediaBindingLiveKit(screenAudioEl, remoteScreenAudioTrack)
</script>

<template>
  <audio
    ref="audioEl"
    autoplay
  />
  <audio
    ref="screenAudioEl"
    autoplay
  />
</template>
